// extracted by mini-css-extract-plugin
export default {"wrapper":"RubleInput_wrapper__o-HCS","inputContainer":"RubleInput_inputContainer__RURcR","input":"RubleInput_input__QJI2a","rubleSign":"RubleInput_rubleSign__ZFE1g"};